import { Controller } from "stimulus"
import { clearLeadCaptureAnswers } from "./lead_capture_session"

export default class extends Controller {
  connect() {
    clearLeadCaptureAnswers(this.element.dataset.leadCaptureSignupId || "")
  }
}
